const base64ToBlob = (base64) => {
  // console.log("base64", base64);
  const byteString = atob(base64.split(",")[1]);
  const mimeString = base64.split(",")[0].split(":")[1].split(";")[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  // console.log("==============================");
  // console.log("base64", base64);
  // console.log("==============================");
  // console.log("MIME STRING", mimeString);
  return new Blob([ia], { type: mimeString });
};

export default base64ToBlob;
